export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/voice_over.8fba726.svg";